<template>
  <!-- 线路维护- EditTransportRoute-->
  <myDialog
    :diaWidth="diaWidth"
    :dialogTitle="dialogTitle"
    :isShowDialog="isShowDialog"
    @handleCloseDia="handleCloseDia"
    @diaCancelBtn="diaCancelBtn"
    @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
  >
    <div class="glo_dialogForm">
      <el-form
        v-if="isShowDialog"
        class="diaForm"
        ref="dialogFormRef"
        :model="dialogForm"
        label-width="110px"
        :rules="rulesForm"
      >
        <el-form-item
          class="dialogFormItems"
          prop="lineName"
          required
          label="运输线路名称:"
        >
          <el-input
            v-model="dialogForm.lineName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="dialogFormItems"
          prop="lineTypeConfDictId"
          required
          label="类型:"
        >
          <el-select
            v-model="dialogForm.lineTypeConfDictId"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in transportLineTypes"
              :value="item.id"
              :key="item.id"
              :label="item.val"
              >{{ item.val }}</el-option
            >
          </el-select>
        </el-form-item>
        <el-form-item
          class="dialogFormItems"
          :label="'始发网点'"
          prop="startDeptId"
          required
        >
          <el-select
            v-model="dialogForm.startDeptId"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="item in businessDepts"
              :key="item.deptId"
              :label="item.deptName"
              :value="item.deptId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="dialogFormItems"
          :label="'到达网点'"
          prop="arriveDeptId"
          required
        >
          <el-select
            v-model="dialogForm.arriveDeptId"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="item in businessDepts"
              :key="item.deptId"
              :label="item.deptName"
              :value="item.deptId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="dialogFormItems"
          prop="isDefault"
          required
          label="默认运输路线:"
        >
          <el-select v-model="dialogForm.isDefault" placeholder="请选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="dialogFormItems"
          prop="isStop"
          required
          label="是否停用:"
        >
          <el-select v-model="dialogForm.isStop" placeholder="请选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="dialogFormItems"
          prop="volumeDivisor"
          required
          label="体积系数:"
        >
          <el-input
            v-model="dialogForm.volumeDivisor"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item class="dialogFormItems" prop="sort" label="排序号:">
          <el-input v-model="dialogForm.sort" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
          <el-input
            type="textarea"
            rows="2"
            v-model="dialogForm.remarks"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="table_content">
        <div class="table_item glo_Table">
          <dept
            :transportLineId="transportLineId"
            :businessDepts="businessDepts"
            ref="dept"
            v-if="isShowDialog"
          />
        </div>
        <div class="table_item glo_Table">
          <city :transportLineId="transportLineId" :type="1" ref="startCity" v-if="isShowDialog"/>
        </div>
        <div class="table_item glo_Table">
          <city :transportLineId="transportLineId" :type="2" ref="arriveCity" v-if="isShowDialog"/>
        </div>
      </div>
    </div>
  </myDialog>
</template>

<script>
import myDialog from "@/components/Dialog.vue";
import Dept from "./Dept.vue";
import City from "./City.vue";
export default {
  components: {
    myDialog,
    Dept,
    City,
  },
  props: {
    transportLineId: {},
  },
  data() {
    return {
      isShowDialog: false,
      dialogTitle: "线路维护",
      diaWidth: "80%",
      dialogForm: {
        id: "",
        lineName: "",
        lineTypeConfDictId: "",
        startDeptId: "",
        arriveDeptId: "",
        isDefault: 0,
        isStop: 0,
        volumeDivisor: "",
        sqNum: "",
        remarks: "",
      },
      rulesForm: {
        lineName: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        lineTypeConfDictId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        startDeptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        arriveDeptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        isDefault: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        isStop: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        volumeDivisor: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      businessDepts: [], // 网点
      branchTableData: [], // 开单网点data
      transportLineTypes: [],
    };
  },
  watch: {
    isShowDialog(n) {
      if (n) {
        this.getBusinessDepts();
        this.getConfDictValDownList(
          "transport_line_type",
          "transportLineTypes"
        );
        this.getDetail();
      } else {
        this.dialogForm = {
          id: "",
          lineName: "",
          lineTypeConfDictId: "",
          startDeptId: "",
          arriveDeptId: "",
          isDefault: 0,
          isStop: 0,
          volumeDivisor: "",
          sqNum: "",
          remarks: "",
        };

        this.branchTableData = [];
      }
    },
  },
  methods: {
    handleChangeBT(val) {},
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia(a) {
      this.isShowDialog = false;
      this.params = {}
    },
    //  弹窗确认保存事件
    diaConfirmBtn(a) {
      const depts = this.$refs.dept.getRows();
      const startCities = this.$refs.startCity.getRows();
      const arriveCities = this.$refs.arriveCity.getRows();
      const params = {
        ...this.dialogForm,
        transportLineDept: depts,
        startCities,
        arriveCities,
      };
      if (!this.dialogForm.id) {
        this.$API
          .addTransportLine(params)
          .then((res) => {
            this.$message.success("保存成功");
            this.isShowDialog = false;
            this.params = {}
            this.$emit("success")            
          })
          .catch((err) => {
            console.log(err)
            this.$message.error("保存失败");
          });
      } else {
        this.$API
          .updateTransportLine(params)
          .then((res) => {
            this.$message.success("保存成功");
            this.isShowDialog = false;
            this.params = {}
            this.$emit("success")            
          })
          .catch((err) => {
            console.log(err)
            this.$message.error("保存失败");
          });
      }
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn(a) {
      this.isShowDialog = false;
    },
    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    async getConfDictValDownList(dictType, field, realFileName) {
      const res = await this.$API.wtl_getConfDictValDownListV5(dictType);
      let arrs = res || [];
      // 其他情况
      this[field] = arrs;
    },
    async getDetail() {
      if (!this.transportLineId) {
        return;
      }
      const res = await this.$API.runList({
        number:'admin_transport_line_detail',
        id:this.transportLineId
      })
      this.dialogForm = {
        ...res[0]
      }
    },
  },
};
</script>

<style lang="less" scoped>
.glo_dialogForm {
  .table_content {
    display: flex;
    justify-content: space-between;
    .table_item {
      width: 32%;
      .title_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
        .title {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  }
  .el-select {
    width: 100%;
  }
}
</style>